module.exports = "/_next/static/images/Hero-3e5d260324c21b0dcb2a828c8cbd312f.webp";